import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../../../../services/apiService';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { Modal } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
function GeneralCaseHistory() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const onboardslug = parts_location[2] || null;
    const taskId = parts_location[3] || null;
    
    const [showhistory, setvalidateHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    

    const fetchData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const defaultParams = { ...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/task/${taskId}/history?${queryString}`);
            if (response && response.success === true) {
                setvalidateHistory(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [taskId]);
    
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchData({ page: newPage });
    };
    useEffect(() => {
        fetchData();
    }, [fetchData,onboardslug]);

    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState({
        data: null,
        fieldHeading: null,
    });
    
    const handleClose = () => setShow(false);
    
    const handleShow = (data, fieldHeading) => {
        setModalData({data, fieldHeading});
        setShow(true);
    };

    const [show2, setShow2] = useState(false);
    const [modalData2, setModalData2] = useState({
        data: null,
        fieldHeading: null,
    });
    
    const handleClose2 = () => setShow2(false);
    
    const handleShow2 = (data, fieldHeading) => {
        setModalData2({data, fieldHeading});
        setShow2(true);
    };

    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Ensure html is always a string
        const safeHtml = typeof html === "string" ? html : JSON.stringify(html);

        const formattedHTML = safeHtml
            .replace(/(\r\n|\r|\n){2,}/g, '<br><br>')
            .replace(/(\r\n|\r|\n)/g, '<br>');

        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        {loading ? 
        <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
            <img style={{ width: "100px" }} src={require('../../../../../assets/pinkloader.gif')} alt='Loading...' />
        </div> :<>
        {showhistory && showhistory.length > 0 ? ( showhistory && showhistory.map((history, index) => (
            <Box key={index} sx={{ mb: 4, overflow: "auto" }}>
                <Grid size={{xs:12}} container justifyContent="space-between" className="span_timeshowers mt-3">
                    <span>{history.datetime}</span>
                    <span><b>Updated by</b> {history.updated_by}</span>
                </Grid>

            {/* Data Grid */}
            <Box sx={{ width: "100%", mt: 2 }} className="dtagridhistory_pagi">
                <DataGrid
                style={{minHeight:"200px"}}
                rows={history.fields.map((field, fieldIndex) => ({
                    id: fieldIndex,
                    field: field?.label,
                    fieldType: field?.field_type,
                    before: field.before || "N/A",
                    after: field.after || "N/A",
                }))}
                columns={[
                    {
                        field: 'field',
                        headerName: 'Field',
                        width: 500,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                <span className='firstlett_caps'>
                                    {params.row.field}
                                </span>
                            </div>
                        ),
                        filterable: false,
                        sortable: false,
                    },
                    { field: "before", headerName: "Before", width: 500,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                {params.row.field === "Assigned User" ?
                                    <span className='firstlett_caps'>{params.row.before}</span>:
                                    <span className='firstlett_caps'>
                                        {params.row.fieldType === "file" ?<>
                                            {params.row.before === "N/A" ?
                                                <>{params.row.before}</> : params.row.before?.length <= 0 ? "N/A" :
                                                <div className='d-flex gap-3'>
                                                    <button
                                                        style={{
                                                            height: "35px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow2(params.row.before, params.row.field)}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                        }
                                        </>
                                        :params.row.fieldType === "datetime" ? 
                                            params.row.before
                                        :<>
                                        {Array.isArray(params.row.before) ? (
                                            params.row.before.join(", ").length <= 40 ? (
                                                <div className='d-flex'>
                                                    {params.row.before.map((item, index) => (
                                                        <div key={index}>
                                                            {item}
                                                            {index < params.row.before.length - 1 && ", "}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <button
                                                    style={{
                                                        height: "35px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className='view_btnhist_kn'
                                                    onClick={() => handleShow(params.row.before.join(", "), params.row.field)}
                                                >
                                                    View
                                                </button>
                                            )
                                        ) : 
                                        params.row.before ? (
                                        params.row.before.length <= 40 ? (
                                            params.row.before
                                        ) : (
                                            <button
                                            style={{
                                                height: "35px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                            className='view_btnhist_kn'
                                            onClick={() => handleShow(params.row.before, params.row.field)}
                                            >
                                            View
                                            </button>
                                        )
                                        ) : (
                                        'N/A'
                                        )}</>
                                    }
                                    </span>
                                }
                            </div>
                        ),
                        filterable: false, sortable: false },
                    { field: "after", headerName: "After", width: 500,
                        renderCell: (params) => (
                            <div className='d-flex align-items-center h-100'>
                                {params.row.field === "Assigned User" ?
                                    <span className='firstlett_caps'>{params.row.after}</span>:
                                    <span className='firstlett_caps'>
                                        {params.row.fieldType === "file" ?<>
                                            {params.row.after === "N/A" ?
                                                <>{params.row.after}</> : params.row.after?.length <= 0 ? "N/A" :
                                                <div className='d-flex gap-3'>
                                                    <button
                                                        style={{
                                                            height: "35px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        className='view_btnhist_kn'
                                                        onClick={() => handleShow2(params.row.after, params.row.field)}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                        }
                                        </>
                                        :params.row.fieldType === "datetime" ? 
                                            params.row.after
                                        :<>
                                        {Array.isArray(params.row.after) ? (
                                            params.row.after.join(", ").length <= 40 ? (
                                                <div className='d-flex'>
                                                    {params.row.after.map((item, index) => (
                                                        <div key={index}>
                                                            {item}
                                                            {index < params.row.after.length - 1 && ", "}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <button
                                                    style={{
                                                        height: "35px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    className='view_btnhist_kn'
                                                    onClick={() => handleShow(params.row.after.join(", "), params.row.field)}
                                                >
                                                    View
                                                </button>
                                            )
                                        ) : 
                                        params.row.after ? (
                                        params.row.after.length <= 40 ? (
                                            params.row.after
                                        ) : (
                                            <button
                                            style={{
                                                height: "35px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                            className='view_btnhist_kn'
                                            onClick={() => handleShow(params.row.after, params.row.field)}
                                            >
                                            View
                                            </button>
                                        )
                                        ) : (
                                        'N/A'
                                        )}</>
                                    }
                                    </span>
                                }
                            </div>
                        ),
                        filterable: false, sortable: false, },
                ]}
                disableSelectionOnClick
                components={{ Toolbar: GridToolbar }}
                />
            </Box>
            </Box>
        ))) : (
            <div className="w-100 d-flex justify-content-center mt-4">
                <p>No data to display</p>
            </div>
        )}</>}
        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
            <button className='arrowpaginate'
                onClick={() => handlePageChange(currentPage - 1)} 
                disabled={currentPage === 1}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            {paginatedata && (
                <div className="pagination">
                    {(() => {
                    const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                    const pages = [];
                    const start = Math.max(2, currentPage - 2);
                    const end = Math.min(totalPages - 1, currentPage + 2);

                    // Always show first page
                    pages.push(
                        <button
                        key={1}
                        onClick={() => handlePageChange(1)}
                        className={currentPage === 1 ? 'active' : ''}
                        >
                        1
                        </button>
                    );

                    if (start > 2) {
                        pages.push(<span key="start-ellipsis">...</span>);
                    }

                    for (let i = start; i <= end; i++) {
                        pages.push(
                        <button
                            key={i}
                            onClick={() => handlePageChange(i)}
                            className={currentPage === i ? 'active' : ''}
                        >
                            {i}
                        </button>
                        );
                    }

                    if (end < totalPages - 1) {
                        pages.push(<span key="end-ellipsis">...</span>);
                    }

                    if (totalPages > 1) {
                        pages.push(
                        <button
                            key={totalPages}
                            onClick={() => handlePageChange(totalPages)}
                            className={currentPage === totalPages ? 'active' : ''}
                        >
                            {totalPages}
                        </button>
                        );
                    }

                    return pages;
                    })()}
                </div>
                )}

            <button className='arrowpaginate'
                onClick={() => handlePageChange(currentPage + 1)} 
                disabled={currentPage === paginatedata.last_page}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </Grid>
        <Modal size='lg' centered show={show} onHide={handleClose}>
            <Modal.Header closeButton className='border-0'>
                <h5 className='my-0'>{modalData?.fieldHeading}</h5>
            </Modal.Header>
            <Modal.Body className='mb-3'><div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData.data) }} /></Modal.Body>
        </Modal>
        <Modal size='md' centered show={show2} onHide={handleClose2}>
            <Modal.Header closeButton className='border-0'>
                <h5 className='my-0'>{modalData2?.fieldHeading}</h5>
            </Modal.Header>
            <Modal.Body className='mb-3 d-flex flex-column'>
                {modalData2?.data?.map((item, index) => (
                    <span className='mb-2'>{index + 1}. <Link to={`${item}`} key={index} target='_blank'>View</Link></span>
                ))}
            </Modal.Body>
        </Modal>
    </div>
)}

export default GeneralCaseHistory
